export const getModalName = state => state.modal.name;
export const getModalData = state => state.modal.data;
